// REISOR_P24G_DRIVER_WORK_COUNTRIES_CATALOG_V1
// One Driver frontend source for registration + profile geography.

export const DEFAULT_DRIVER_WORK_COUNTRIES = Object.freeze([]);

export const DRIVER_WORK_COUNTRIES = Object.freeze([
  ["UZ", "O‘zbekiston"],
  ["RU", "Россия"],
  ["KZ", "Қазақстан"],
  ["KG", "Кыргызстан"],
  ["TJ", "Тоҷикистон"],
  ["TM", "Türkmenistan"],
  ["CN", "中国 / Китай"],
  ["TR", "Türkiye"],
  ["BY", "Беларусь"],
  ["AF", "Afghanistan"],
  ["AZ", "Azərbaycan"],
  ["GE", "Грузия"],
  ["AM", "Армения"],
  ["IR", "Иран"],
  ["AE", "БАА"],
  ["LT", "Литва"],
  ["LV", "Латвия"],
  ["EE", "Эстония"],
  ["PL", "Польша"],
  ["DE", "Германия"],
]);

export const DRIVER_WORK_COUNTRY_LABELS = Object.freeze(
  Object.fromEntries(DRIVER_WORK_COUNTRIES.map(([code, label]) => [code, label]))
);

export function driverWorkCountryLabel(value) {
  const code = String(value || "").trim().toUpperCase();
  return DRIVER_WORK_COUNTRY_LABELS[code] || code;
}

const ALLOWED = new Set(DRIVER_WORK_COUNTRIES.map(([code]) => code));

export function normalizeDriverWorkCountriesSelection(
  value,
  { defaultWhenEmpty = false } = {}
) {
  const out = [];
  const seen = new Set();

  for (const item of Array.isArray(value) ? value : []) {
    const code = String(item || "").trim().toUpperCase();
    if (!ALLOWED.has(code) || seen.has(code)) continue;
    seen.add(code);
    out.push(code);
  }

  if (!out.length && defaultWhenEmpty) return [...DEFAULT_DRIVER_WORK_COUNTRIES];
  return out;
}
